import { apiFetchBase, ApiFetchBaseOptions, wrappedApiFetchBase } from '@payer-admin-ui/components/src/utils/http';
import { WrappedResponse } from '@payer-admin-ui/components/src/utils/WrappedResponse';

// TODO when all api calls use the wrapped versions, remove the unwrapped versions and rename the wrapped versions to
// not use prefix "wrapped"

const apiFetch = <T>(
  url: string,
  { query = {}, method, headers = {}, body, bodyIsJson = true, responseType }: ApiFetchBaseOptions = {},
): Promise<T | string | Blob | null> => {
  return apiFetchBase<T>(`/merchant-admin/api${url}`, { query, method, headers, body, bodyIsJson, responseType }, true);
};

const apiPost = <T>(
  url: string,
  { query = {}, headers = {}, body, bodyIsJson = true, responseType }: ApiFetchBaseOptions = {},
): Promise<T | string | Blob | null> => {
  return apiFetch(url, { method: 'POST', headers, query, body, bodyIsJson, responseType });
};

const apiPut = <T>(
  url: string,
  { query = {}, headers = {}, body, bodyIsJson = true, responseType }: ApiFetchBaseOptions = {},
): Promise<T | string | Blob | null> => {
  return apiFetch(url, { method: 'PUT', headers, query, body, bodyIsJson, responseType });
};

const apiGet = <T>(
  url: string,
  { query = {}, headers = {}, responseType }: ApiFetchBaseOptions = {},
): Promise<T | string | Blob | null> => {
  return apiFetch(url, { method: 'GET', headers, query, responseType });
};

const wrappedApiFetch = <T>(
  url: string,
  { query = {}, method, headers = {}, body, bodyIsJson = true, responseType }: ApiFetchBaseOptions = {},
): WrappedResponse<T> => {
  return wrappedApiFetchBase<T>(
    `/merchant-admin/api${url}`,
    { query, method, headers, body, bodyIsJson, responseType },
    true,
  );
};

const wrappedApiPost = <T>(
  url: string,
  { query = {}, headers = {}, body, bodyIsJson = true, responseType }: ApiFetchBaseOptions = {},
): WrappedResponse<T> => {
  return wrappedApiFetch(url, { method: 'POST', headers, query, body, bodyIsJson, responseType });
};

const wrappedApiPut = <T>(
  url: string,
  { query = {}, headers = {}, body, bodyIsJson = true, responseType }: ApiFetchBaseOptions = {},
): WrappedResponse<T> => {
  return wrappedApiFetch(url, { method: 'PUT', headers, query, body, bodyIsJson, responseType });
};

const wrappedApiGet = <T>(
  url: string,
  { query = {}, headers = {}, responseType }: ApiFetchBaseOptions = {},
): WrappedResponse<T> => {
  return wrappedApiFetch(url, { method: 'GET', headers, query, responseType });
};

export { apiFetch, apiPost, apiPut, apiGet, wrappedApiGet, wrappedApiPost, wrappedApiPut, wrappedApiFetch };
